import React from 'react'
import styled from 'styled-components'
import { Link } from '@sketch/components'
import {
  InspectorComponentLinkProps,
  colorVariableLinkStyles,
} from '@sketch/inspector'
import { VersionLink } from '../../../../versioning'
import { useComponentDocumentLink } from './useComponentDocumentLink'

const LinkStyled = styled(Link)`
  ${colorVariableLinkStyles}
`

const VersionLinkStyled = styled(VersionLink)`
  ${colorVariableLinkStyles}
`

/**
 * Links an inspected component to the document it lives in.
 *
 * Supplied to `@sketch/inspector` through `InspectorHostProvider`: building
 * this link needs the app's routes and its current version, neither of which
 * the inspector package knows about.
 *
 * A foreign component always links to the latest version of its own document,
 * while a component from the document being viewed gets a versioned link.
 */
export function InspectorComponentLink({
  isForeign,
  shareID,
  search,
  children,
}: InspectorComponentLinkProps) {
  const link = useComponentDocumentLink({
    routeKey: 'CWV_COLOR_VARIABLES',
    isForeign,
    shareID,
    search,
  })

  if (!link.isVersioned) {
    return (
      <LinkStyled target="_blank" to={link.to}>
        {children}
      </LinkStyled>
    )
  }

  return (
    <VersionLinkStyled target="_blank" to={link.to}>
      {children}
    </VersionLinkStyled>
  )
}
